import { forwardRef, type VideoHTMLAttributes } from "react";
import type { VideoClip } from "@/lib/bilspektrumVideos";

type Props = Omit<VideoHTMLAttributes<HTMLVideoElement>, "src" | "poster"> & {
  clip: VideoClip;
};

/**
 * Background video with a portrait file for phones and a landscape file for
 * larger screens. The browser picks the source via `media`, so no JS or
 * layout flash is needed.
 */
export const ResponsiveVideo = forwardRef<HTMLVideoElement, Props>(function ResponsiveVideo(
  { clip, muted = true, playsInline = true, ...props },
  ref
) {
  return (
    <video ref={ref} muted={muted} playsInline={playsInline} poster={clip.poster} {...props}>
      <source src={clip.mobile} type="video/mp4" media="(max-width: 767px) and (orientation: portrait)" />
      <source src={clip.desktop} type="video/mp4" />
    </video>
  );
});
